<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span>{{ 'components.clinical-onboarding.clinician-detail.add-document-title' | translate }}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="!saving ? closeDialogue() : ''"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

@if (saving) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="container my-4">
    <p class="hint-text mb-3">{{ 'components.clinical-onboarding.clinician-detail.add-document-hint' | translate }}</p>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'components.clinical-onboarding.document-templates.field-title' | translate }}</mat-label>
      <input matInput formControlName="title" maxlength="255">
      @if (form.get('title').hasError('required')) {
        <mat-error>{{ 'swal.errors.field-mandatory' | translate }}</mat-error>
      }
    </mat-form-field>

    <p class="field-group-label mt-2">{{ 'components.clinical-onboarding.document-templates.field-requires-upload' | translate }}</p>
    <mat-radio-group formControlName="requires_upload" class="d-flex flex-column">
      <mat-radio-button [value]="false" class="mb-2">
        {{ 'components.clinical-onboarding.document-templates.requires-upload-false' | translate }}
      </mat-radio-button>
      <mat-radio-button [value]="true">
        {{ 'components.clinical-onboarding.document-templates.requires-upload-true' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="buttons-container container mb-3 d-flex justify-content-center">
    <button mat-stroked-button class="text-dark-purple border-purple mr-2" type="button" [disabled]="saving" (click)="closeDialogue()">{{ 'generic.buttons.cancel-and-back' | translate }}</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="saving">{{ 'generic.buttons.save' | translate }}</button>
  </div>
</form>
